import { h, Component } from 'preact';
import style from './style.css';
import Header from '../Header'
import cx from 'classnames';
import { goToTop } from 'react-scrollable-anchor'

const faqItems = [
    {
        title: 'How are the player points calculated?',
        description: 'Player Index uses a unique algorithm fed by historic data, current conditions and strength of opposition, amongst a number of other heuristics to produce a ‘Player Performance Score’ (PPS) which is then translated into a live price which updates in-running.<br />We use players’ performance data supplied live by Opta and RunningBall to measure each player’s performance score within our algorithm.'
    },
    {
        title: 'What happens to my bet if a player gets sent off or has an injury?',
        description: 'A player’s points are settled at the end of the match. If a player is sent off or injured during the match, this will not affect his final total. For example, if a player has 70 points when he is substituted in the 83rd minute, his final total will be 70 points.'
    },
    {
        title: 'Can I follow one specific player',
        description: 'Yes, you can. You can ‘star’ a player who will then appear in your favourites page, where you can track their previous performances see their upcoming matches.'
    },
    {
        title: 'Can I share my thoughts and in-play ideas with friends?',
        description: 'It is on our future roadmap, to add a social media links to the game.'
    },
    {
        title: 'Can I place multiple bets on a player in play?',
        description: 'Yes, you can bet on any player at any time during or before the match (providing betting isn’t suspended due to the state of the game).'
    },
    {
        title: 'Can I link my fantasy football players to Player Index?',
        description: 'Not at the moment, but it will be on our future roadmap'
    }
]

class Faq extends Component {
    render(props) {
        goToTop()
    return <div className={cx(style.list, 'flex', 'flex-col')}>
        <Header leadingSlash='/' />
        <div>
            <div><h1>FAQ</h1></div>
            {faqItems.map((faqItem) => (
                <div>
                    <h3>{faqItem.title}</h3>
                    <span>{faqItem.description}</span>
                </div>
            ))}
        </div>
    </div>;
    }
}

export default Faq;


// WEBPACK FOOTER //
// ./components/Faq/index.jsx